/** 1 unit = 1 m. Island is 1536 m, play origin at the Crash Coast sand. */
export const CHUNK_SIZE = 64;
export const ISLAND_SIZE = 1536;
export const ISLAND_CHUNKS = ISLAND_SIZE / CHUNK_SIZE;
export const ISLAND_HALF = ISLAND_SIZE / 2;
export const ISLAND_MIN = -ISLAND_HALF;
export const ISLAND_MAX = ISLAND_HALF;
/** Cells per chunk. 64 cells × 1 m + shared edge = 65 verts. */
export const HEIGHT_CELLS = 64;
export const HEIGHT_VERTS = HEIGHT_CELLS + 1;

export type HeightSampler = (x: number, z: number) => number;

/**
 * Greybox dressing and the PhysicsWorld safety crust sit on y = 0.
 * Relief stays 0 so existing slabs / e2e teleports (y = 2) still stand.
 */
const defaultHeight: HeightSampler = () => 0;

let sampler: HeightSampler = defaultHeight;

export function setHeightSampler(fn: HeightSampler | null): void {
  sampler = fn ?? defaultHeight;
}

export function heightAt(x: number, z: number): number {
  return sampler(x, z);
}

export function inIsland(x: number, z: number): boolean {
  return x >= ISLAND_MIN && x < ISLAND_MAX && z >= ISLAND_MIN && z < ISLAND_MAX;
}

/** Column-major Rapier height matrix for one 64 m cell. Shared edges match. */
export function sampleChunkHeights(cx: number, cz: number): Float32Array {
  const ox = cx * CHUNK_SIZE;
  const oz = cz * CHUNK_SIZE;
  const heights = new Float32Array(HEIGHT_VERTS * HEIGHT_VERTS);
  for (let j = 0; j < HEIGHT_VERTS; j++) {
    for (let i = 0; i < HEIGHT_VERTS; i++) {
      heights[j * HEIGHT_VERTS + i] = heightAt(ox + j, oz + i);
    }
  }
  return heights;
}
